module.exports = __webpack_public_path__ + "img/377-04e785.png";